type IItem = {
    sortOrder?: number | null;
    isUpsellItem?: boolean | null;
};

function sort<TItem extends IItem>(items: TItem[]): TItem[] {
    return items.sort((first, second) => {
        if (!first.sortOrder && !second.sortOrder) {
            return 0;
        }

        if (!first.sortOrder) {
            return -1;
        }

        if (!second.sortOrder) {
            return 1;
        }

        return first.sortOrder > second.sortOrder ? 1 : -1;
    });
}

/**
 * Sorts the items - first by type (item/upsell), then by sortOrder.
 * @param items the items
 * @returns the sorted items
 */
export function sortItems<TItem extends IItem>(items: TItem[]): TItem[] {
    const promotionItems = sort(items.filter(item => !item.isUpsellItem));
    const upsellItems = sort(items.filter(item => item.isUpsellItem));

    return promotionItems.concat(upsellItems);
}
